import {useContext} from "react";

import {NotificationStateContext} from "./internal/context.ts";
import type {NotificationState} from "./internal/reducer.ts";

/**
 * Hook to consume Khanmigo's notification state/context.
 */
export const useNotificationState = (): NotificationState => {
    const context = useContext(NotificationStateContext);
    if (context === null) {
        throw new Error(
            "useNotificationState must be used within a NotificationStateProvider",
        );
    }
    return context;
};
